module.exports = __webpack_public_path__ + "static/media/default-fallback.028ed8a5.svg";